module.exports = __webpack_public_path__ + "img/user.7d2a05d4.svg";